module.exports = __webpack_public_path__ + "static/media/eject.344a448a.svg";